const firebaseConfig = {
    apiKey: "AIzaSyAtpQHEBj_2NTePIKj4jYbk7trU9snhdvE",
    authDomain: "my-auth-a7c70.firebaseapp.com",
    projectId: "my-auth-a7c70",
    storageBucket: "my-auth-a7c70.appspot.com",
    messagingSenderId: "326477436983",
    appId: "1:326477436983:web:ac7cb0a292f650c9e287b2"
  };

  export default firebaseConfig;